import React from 'react';

class Image extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <section className="section">
                <div className="main-container">
                    <div className="inner-container">
                        <div class="vimeo-wrapper ml-auto mr-auto" style={{'--maxW' : '1308px'}}>
                            <iframe src={`https://player.vimeo.com/video/${this.props.id}?autoplay=1&amp;loop=1&amp;autopause=0&amp;title=0&amp;byline=0&amp;portrait=0&amp;background=1`} frameborder="0"></iframe>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Image;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/VimeoVideo.js